import type * as StandardPage from '../types/StandardPage'
import parseComponent from '../../components/parsers'
import type { Component } from '../../components/types'
import { socialMetaDataParser } from '.'

export default function standardPageParser(
  rawResponse: StandardPage.Raw,
): StandardPage.Parsed {
  const { acf, title, breadcrumbs, contentType } = rawResponse.tiles[0]
  const { components, fullPath } = acf

  const metaData = {
    breadcrumbs,
    contentType,
    title,
    socialMetaData: socialMetaDataParser(rawResponse),
    path: fullPath,
  }

  return {
    ...metaData,
    components: components
      .map(parseComponent)
      .filter((component): component is Component => !!component),
  }
}
